import { error2text } from 'core/utils';
import AsideTogglerMixin from './AsideTogglerMixin';

export default {
  mixins: [AsideTogglerMixin],

  data() {
    return {
      loading: true,
    };
  },

  mounted() {
    console.log('mounted()');
    console.log('this', this);
    this.toggleAside(false);
    this.$emit('breadcrumbs', this.breadcrumbs);
  },

  watch: {
    breadcrumbs(newValue) {
      this.$emit('breadcrumbs', newValue);
    }
  },

  methods: {
    /*
    onError0({ statusCode, data }) {
      console.log('onError0', statusCode, data);
      alert(error2text(data));
    },
    */

    onError422({ statusCode, data }) {
      console.error('onError422', statusCode, data);
      if (data === undefined || data === null) {
        const message = error2text(data);
        alert(message);
      } else if (typeof data === 'string') {
        console.log('data is a string');
        try {
          const json = JSON.parse(data);
          if (json) {
            console.log('json', json);
            alert('Ci sono degli errori di validazione');
            this.errors = json.message;
          }
        } catch (e) {
          //console.log('Error processing json', e);
          const message = error2text(data);
          alert(message);
        }
      } else if (typeof data === 'object') {
        console.log('data is an object');
        alert('Ci sono degli errori di validazione');
        this.errors = data;
      }
    },

    onError401({ statusCode, data }) {
      console.log('onError401', statusCode, data);
      const message = 'Utente non autenticato'; //error2text(data);
      alert(message);
      const redirect = '/public/login';
      if (this.$router) {
        this.$router.push({
          path: redirect,
          query: { redirect: this.$route.fullPath }
        });
      }
    },

    onError403({ statusCode, data }) {
      console.log('onError403', statusCode, data);
      // const message = error2text(data);
      // alert(message);
      if (this.$router) {
        this.$router.push({
          name: 'ProtectedPage403',
        });
      }
    },

    onError404({ statusCode, data, doNotRedirect }) {
      console.log('onError404', statusCode, data);
      // const message = error2text(data);
      // alert(message);
      if (doNotRedirect || !this.$router) {
        this.onAnyError({ statusCode, data });
      } else {
        this.$router.push({
          name: 'ProtectedPage404',
        });
      }
    },

    onAnyError({ statusCode, data }) {
      console.log('onAnyError', statusCode, data);
      const message = error2text(data);
      alert(message);
    },

    handleError({ statusCode, data, doNotRedirect }) {
      const key = 'onError' + statusCode;
      if (this[key]) {
        this[key]({ statusCode, data, doNotRedirect });
      } else {
        this.onAnyError({ statusCode, data });
      }
      if (this.loading !== undefined) {
        this.loading = false;
      }
    },
  }
};
